export default {
  "content": "<title>Battery Dead</title><rect x=\"31\" y=\"144\" width=\"400\" height=\"224\" rx=\"45.7\" ry=\"45.7\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M479 218.67v74.66\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};